import { useState, useEffect, useContext } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { BookValuesContext, BookLocationDocumentValuesContext } from 'contexts';
import { getLocalSettingsProxy } from 'utilities';

export const usePDFWarning = () => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
  const { book } = useContext(BookValuesContext);
  const { currentBookLocationDocument } = useContext(
    BookLocationDocumentValuesContext,
  );

  const [shouldOpenPDFWarningDialog, setShouldOpenPDFWarningDialog] =
    useState(false);

  const [localSettings] = useState(getLocalSettingsProxy(book?.pk));

  useEffect(() => {
    if (
      localSettings.shouldShowPDFWarning &&
      currentBookLocationDocument?.fixedWidth &&
      isMobile
    ) {
      setShouldOpenPDFWarningDialog(true);
      localSettings.shouldShowPDFWarning = false;
    }
  }, [isMobile, localSettings, currentBookLocationDocument?.fixedWidth]);

  return {
    shouldOpenPDFWarningDialog,
    setShouldOpenPDFWarningDialog,
  };
};
